import { CommonModule } from '@angular/common';
import { Component,OnInit,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from '../../services/api';
import { AuthService } from '../../services/auth-service';

@Component({
  selector: 'app-book-live-session-slot',
  standalone: false,
  templateUrl: './book-live-session-slot.html',
  styleUrl: './book-live-session-slot.scss'
})
export class BookLiveSessionSlot implements OnInit{
@Input() courseData: any;
lecName:any = ""
days:any[]=[];
allSessions:any [] = [];
selectedIndex=0;
openModel:boolean= false
sessions:any={};
user:any;
data: { slotDate: any; name: any ; availableSeats:any ; sessionid: any; modulename:any,date:any,oldsessionID:any,bookingId:any,lectureID:any,editflag:any} = {
  slotDate: '',
  name: '',
  availableSeats: '',
  sessionid: '',
  oldsessionID: '',
  bookingId: '',
  lectureID: '',
  modulename: '',
  date: '',
  editflag: ''
}
sessionn:any = ''
selectedSessions:any[]=[];

constructor(private activatedRoute: ActivatedRoute,private router: Router, private Apiservice: Api,public authService: AuthService){
   const userString = this.authService.getUser();

  if (userString) {
    this.user = typeof userString === 'string'
      ? JSON.parse(userString)
      : userString;

    
  }
}

//   lecturename: '',
//   lectureID: ''
// };
ngOnInit(){
console.log("this.courseData",this.courseData)
this.lecName = this.courseData.lecturename
this.getAllsession(this.courseData.lectureID,this.user.schoolId)
this.generateDays();
this.selectDay(0);
 this.Apiservice.bookingSuccess$.subscribe(success => {
  console.log("Parent received:", success);

  if(success){
    alert("closing modal");
    this.closemodel();
  }
});

}


generateDays(){

  this.days = []; // clear previous days

  const sessionDates = Object.keys(this.allSessions); // get dates from API

  for(let i = 0; i < sessionDates.length; i++){

    let d = new Date(sessionDates[i]);

    this.days.push({

      day: d.toLocaleDateString('en',{weekday:'short'}).toUpperCase(),

      date: d.getDate(),

      month: d.toLocaleDateString('en',{month:'short'}).toUpperCase(),

      full: d.toISOString().split('T')[0]

    });

  }

}

selectDay(i: number) {

  this.selectedIndex = i;

  const selectedDate = this.days[i].full;

  this.selectedSessions = this.allSessions[selectedDate] || [];

  console.log("Selected Sessions:", this.selectedSessions);

}


book(session:any,slot:any){

alert(session.name+" booked at "+slot);

}
openmodel(selectedSlot:any,sessionid:any,lecname:any,availableseats:any,selectedate:any){
  console.log("session",selectedate)
   if(availableseats === 0){
   this.Apiservice.displayToast("No slots available for booking.", 500);
    return;
   }
   else{
   console.log("sessionid",sessionid)
   this.data.slotDate = selectedSlot;
   this.data.name = lecname;
   this.data.availableSeats = availableseats;
   this.data.sessionid = sessionid;
   this.data.modulename = this.courseData.moduleName;
   this.data.date = selectedate;
   this.data.oldsessionID = this.courseData.sessionId;
   this.data.bookingId = this.courseData.bookingId;
   this.data.lectureID = this.courseData.lectureID;
   this.data.editflag = this.courseData.editflag;
   this.openModel = true;
   }
 
}
closemodel(){
   this.openModel = false;
}

getAllsession(Id:any,schoolid:any){
  this.Apiservice.getavailablesessions(Id,schoolid).subscribe((result: any) => {
        this.allSessions = result.data || {};
        
    this.generateDays();   // generate based on API dates

    this.selectDay(0);     // select first date
         
        })
    }

isPastSession(slotTime: string, sessionDate: string): boolean {
  if (!slotTime || !sessionDate) return true;

  // Clean time (remove AM/PM if incorrect format like "14:00 PM")
  let cleanTime = slotTime.replace(/(AM|PM)/i, '').trim();

  const [hours, minutes] = cleanTime.split(':').map(Number);

  // Create session full datetime
  const sessionDateTime = new Date(sessionDate);
  sessionDateTime.setHours(hours, minutes, 0, 0);

  // Current datetime
  const now = new Date();

  return sessionDateTime <= now;
}
}



